export default "__VITE_ASSET__D9s55qF0__"